/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const queryPaginationNext = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M5 13.5h3v-3H5v3zm5 0h3v-3h-3v3zM17 9l-1 1 2 2-2 2 1 1 3-3-3-3z" />
	</SVG>
);

export default queryPaginationNext;
